export const RatingStars = ({ rating, dark = false }) => {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  return (
    <span
      data-testid="rating-stars"
      className={`inline-flex items-center gap-1 font-mono text-sm ${dark ? "text-petal-soft" : "text-petal"}`}
      aria-label={`${rating} out of 5 stars`}
    >
      {Array.from({ length: 5 }).map((_, i) => (
        <span key={i} className="text-base leading-none">
          {i < full ? "★" : i === full && half ? "⯨" : "☆"}
        </span>
      ))}
      <span className="ml-1">{rating.toFixed(1)}</span>
    </span>
  );
};

export const ScoreBar = ({ label, value, dark = true }) => (
  <div data-testid={`score-bar-${label.toLowerCase()}`} className="space-y-1.5">
    <div className="flex justify-between items-baseline">
      <span className={`text-xs font-mono tracking-widest uppercase ${dark ? "text-sage-light" : "text-sage"}`}>{label}</span>
      <span className={`font-mono text-sm ${dark ? "text-cream" : "text-ink"}`}>{value}/5</span>
    </div>
    <div className={`h-1.5 rounded-full overflow-hidden ${dark ? "bg-cream/10" : "bg-pine/10"}`}>
      <div
        className="h-full rounded-full bg-petal transition-all duration-700"
        style={{ width: `${(value / 5) * 100}%` }}
      />
    </div>
  </div>
);
